<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <p>①　Khởi động trình duyệt web mà bạn muốn sử dụng.</p>
                    <p>※ Các trình duyệt được hỗ trợ: Chrome, Microsoft Edge, Firefox</p>
                </div>
                <div><img src="/static\images\vi\newManual\logo_browse_1.png" alt="" /></div>
                <div>
                    <p>②　Truy cập vào đường link bên dưới.</p>
                    <p><a href="https://www.studyarts.vn/">https://www.studyarts.vn/</a></p>
                </div>
                <div><img src="/static\images\vi\newManual\manual_pc_new_1.png" alt="" /></div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <p>①　Khởi động trình duyệt web mà bạn muốn sử dụng.</p>
                    <p>※ Các trình duyệt được hỗ trợ: Chrome, Microsoft Edge, Firefox</p>
                </div>
                <div><img src="/static\images\vi\newManual\logo_browse_1.png" alt="" /></div>
                <div>
                    <p>②　Truy cập vào đường link bên dưới.</p>
                    <p><a href="https://www.studyarts.vn/">https://www.studyarts.vn/</a></p>
                </div>
                <div><img src="/static\images\vi\newManual\manual_pc_new_1.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/usingPc_manual.vue